import classNames from "classnames";
import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionCategoryRow } from "../viewUtils";
import styles from "../children/CategoryItem.module.scss";

export const PercentageCell = memo(function PercentageCell({
    row,
}: CellContext<ViewTableFeatures, TransactionCategoryRow, unknown>) {
    const { percentage } = row.original;

    if (isNaN(percentage)) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <span
                className={classNames(styles.label, {
                    [styles.zero]: percentage === 0,
                })}
            >
                {percentage.toFixed(1)}%
            </span>
        </ViewTableCell>
    );
});
